/* External */
import { useCallback, useEffect, useState } from 'react';

/* Other */
import { getJsonImage } from 'src/theme/images';

/* Theme Assets */
import newsIcon from '~/assets/theme/svg/news.svg';

/* Utils */
import { getCurableBannerById } from '../services/banner';

export default function useFetchCurableBanner(bannerId, isCurableBannerActive) {
  const [data, setData] = useState({});
  const defaultIcon = getJsonImage('news') || newsIcon;

  const handleGetCurableBanner = useCallback(() => {
    getCurableBannerById(bannerId).then((response) => {
      const {
        title, description: subtitle, link, fixedPhrase, icon,
      } = response?.data || {};
      setData({
        title,
        subtitle,
        link,
        fixedPhrase,
        icon: icon || defaultIcon,
      });
      return true;
    }).catch((error) => {
      console.error('banner>useFetchBanner', error);
      return false;
    });
  }, [bannerId, defaultIcon]);

  useEffect(() => {
    if (bannerId && isCurableBannerActive) {
      handleGetCurableBanner();
    }
  }, [bannerId, isCurableBannerActive, handleGetCurableBanner]);

  return data;
}
